import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { CourtProcedureType } from 'src/types';
import { PayeePopupComponent } from '../../../shared/payee-popup/payee-popup.component';
import { PayeeButtonComponent } from '../../../shared/payee-buttons/payee-button/payee-button.component';

export type DebtorCourtProcedureDialogData =
  | {
    variant: 'court_procedure';
    court_procedure_type: CourtProcedureType;
  }
  | {
    variant: 'inactive';
    company_status: 'suspended' | 'unknown';
  }
  | {
    variant: 'terminated_sole_entrepreneur';
  };

@Component({
  selector: 'app-debtor-court-procedure-dialog',
  templateUrl: './debtor-court-procedure-dialog.component.html',
  styleUrls: ['./debtor-court-procedure-dialog.component.scss'],
  imports: [PayeePopupComponent, PayeeButtonComponent, TranslateModule],
})
export class DebtorCourtProcedureDialogComponent {
  private dialogRef = inject<MatDialogRef<DebtorCourtProcedureDialogComponent>>(MatDialogRef);
  private translate = inject(TranslateService);
  readonly data = inject<DebtorCourtProcedureDialogData>(MAT_DIALOG_DATA);

  readonly lawFirmPhone = '+36309683882';
  readonly lawFirmEmail = 'zsolt@cziborugyvediiroda.hu';

  get isCourtProcedure(): boolean {
    return this.data.variant === 'court_procedure';
  }

  get isTerminatedSoleEntrepreneur(): boolean {
    return this.data.variant === 'terminated_sole_entrepreneur';
  }

  get isInactiveCompany(): boolean {
    return this.data.variant === 'inactive';
  }

  get procedureTypeLabel(): string {
    if (this.data.variant !== 'court_procedure') {
      return '';
    }

    return this.translate.instant(
      `CASE_FORM.FORMS.DEBTOR.COURT_PROCEDURE_DIALOG.PROCEDURE_TYPES.${this.data.court_procedure_type}`,
    );
  }

  get authorityLabel(): string {
    if (this.data.variant !== 'court_procedure') {
      return '';
    }

    const authorityKey =
      this.data.court_procedure_type === 'voluntary_liquidation'
        ? 'voluntary_liquidation'
        : 'liquidation';

    return this.translate.instant(
      `CASE_FORM.FORMS.DEBTOR.COURT_PROCEDURE_DIALOG.AUTHORITIES.${authorityKey}`,
    );
  }

  confirm(): void {
    this.dialogRef.close();
  }
}
